<template>
  <div>
    <wc-data-box
      :title='$store.state.icons.dataBox.basics.title'
      :titleIcon='$store.state.icons.dataBox.basics.icon'
      :titleIconColor='$store.state.icons.dataBox.basics.iconColor'
      :showEdit='!invoice.archived && !invoice.is_uncollectible'
      showHelp
      :helpText='helpText'
      @edit='editBasics'
    >
      <wc-two-column-table
        :items='data'
      ></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='$store.state.icons.dataBox.basics.title'
      :icon='$store.state.icons.dataBox.basics.icon'
      :iconColor='$store.state.icons.dataBox.basics.iconColor'
      @cancel='showDialog = false'
      :loadingButtons='isLoading'
      width='350'
      :disableButtons='!isFormValid || isLoading'
      @save='updateInvoice'
    >
      <v-form v-model='isFormValid'>
        <client-form-search
          v-model='invoice_edit.bill_to'
          label='Bill to'
          @updateQuickpicks='handleBillToSelection'
          @loading='setLoading'
        ></client-form-search>
        <client-form-search
          v-model='invoice_edit.send_to'
          label='Send to'
          @loading='setLoading'
          @updateQuickpicks='handleSendToSelection'
          hint="Leave blank to send to the 'Bill To' contact"
        ></client-form-search>
        <br>
        <wc-datepicker
          :disabled='!invoice.date_sent'
          :hint="!invoice.date_sent ? 'Invoice not sent - cannot adjust invoice date' : ''"
          v-model='invoice_edit.invoice_date'
          label='Create Date'
        ></wc-datepicker>
        <br>
        <wc-datepicker
          :disabled='!invoice.date_sent'
          :hint="!invoice.date_sent ? 'Invoice not sent - cannot adjust invoice date' : ''"
          :persistent-hint='!invoice.date_sent'
          :required='invoice.date_sent && invoice.date_sent.length > 0'
          v-model='invoice_edit.date_due'
          :min='this.$store.state.misc.accounting_settings.closed_fiscal_date'
          label='Invoice date'
        ></wc-datepicker>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import projectServices from '@/modules/projects/services/projects';
import ClientFormSearch from '@/modules/clients/components/ClientFormSearch';
import formRules from '@/mixins/formRules';
const BILL_TO = 'Bill to';
const SEND_TO = 'Send to';

export default {
  name: 'invoice-basics',
  mixins: [formRules],
  props: {
    invoice: {
      required: true
    }
  },
  data: () => ({
    data: [],
    isLoading: false,
    isFormValid: false,
    showDialog: false,
    invoice_edit: {},
    helpText: '<strong>Date Created:</strong><br>This is the date the invoice was created either by the CPM automatically, or by a staff member.<br><br>' +
    '<strong>Due Date:</strong><br>' + 
    'The due date is set when the invoice is sent to the customer. If the due date is empty, then the invoice has not been sent to the customer. ' +
    'Without a due date, the invoice will not be considered collectible and will not show up in any revenue reports.<br><br>' + 
    'The due date is also the only date that will be presented on the invoice the client receives.'
  }),
  created () {
    this.getData()
  },
  computed: {
    projectRoute () {
      if (this.invoice.project !== null) {
        const routeName = projectServices.getProjectOverviewRoute(this.invoice.project_obj);
        return { name: routeName, params: { id: this.invoice.project } }
      }
      return null;
    },
  },
  methods: {
    editBasics () {
      this.invoice_edit = {
        "bill_to": this.invoice.bill_to,
        "send_to": this.invoice.send_to,
        "date_due": this.invoice.date_due,
        "invoice_date": this.invoice.invoice_date
      }
      this.showDialog = true;
    },
    updateInvoice () {
      this.$emit('update', this.invoice.id, this.invoice_edit);
      this.updateData();
      this.showDialog = false;
    },
    setLoading (val) {
      this.isLoading = val;
    },
    updateData(){
      this.data.map(item =>{
        if(item.text === "Create Date"){
            item.value = this.$options.filters.longDate(this.invoice_edit.invoice_date);
        }
        if(item.text === BILL_TO){
          const index = this.data.indexOf(item);
          const updated_bill_to = {
            text: BILL_TO,
            value: this.invoice_edit.bill_to ? this.invoice_edit.bill_to_display : '',
            route: this.invoice_edit.bill_to ? { name: 'ClientOverview', params: { id: this.invoice_edit.bill_to } } : ''
          }
          this.data.splice(index, 1, updated_bill_to);
        }
        if(item.text === SEND_TO){
          const index = this.data.indexOf(item);
          const updated_send_to = {
            text: SEND_TO, 
            value: this.invoice_edit.send_to ? this.invoice_edit.send_to_display : this.invoice_edit.bill_to ? this.invoice_edit.bill_to_display : "",
            route: this.invoice_edit.send_to ? { 
              name: 'ClientOverview', 
              params: { 
                id: this.invoice_edit.send_to } } : this.invoice_edit.bill_to ? { 
                  name: 'ClientOverview', 
                  params: { 
                    id: this.invoice_edit.bill_to } } : null
          }
          this.data.splice(index, 1, updated_send_to);
        }
      });
    },
    getData () {
      this.invoice.is_template !== true ? this.data.push({ text: 'Number', value: this.invoice.number }) : '';

      console.log(this.invoice);

      this.data.push({
        text: BILL_TO,
        value: this.invoice.bill_to ? this.invoice.bill_to_obj.name_display : '',
        route: this.invoice.bill_to ? { name: 'ClientOverview', params: { id: this.invoice.bill_to } } : ''
      });

      this.data.push({
        text: SEND_TO,
        value: this.invoice.send_to ? this.invoice.send_to_obj.name_display : this.invoice.bill_to ? this.invoice.bill_to_obj.name_display : "",
        route: this.invoice.send_to ? { 
          name: 'ClientOverview', 
          params: { 
            id: this.invoice.send_to } } : this.invoice.bill_to ? { 
              name: 'ClientOverview', 
              params: { 
                id: this.invoice.bill_to } } : null
      });

      if (this.invoice.project) {
        this.data.push({ text: 'For Project', value: this.invoice.project_obj.name, route: this.projectRoute });
      } else {
        this.data.push({ text: 'For Project', value: 'none' });
      }

      if (this.invoice.work_order) {
        this.data.push({
          text: 'For Work Order',
          value: this.invoice.work_order_obj.number,
          route: {
            name: 'WOOverview',
            params: {
              id: this.invoice.work_order
            }
          }
        });
      } else {
        this.data.push({
          text: 'For Work Order',
          value: 'none' });
      }

      this.data.push({ 
        text: 'Create Date', 
        value: this.$options.filters.longDate(this.invoice.invoice_date) });

      if (this.invoice.is_template !== true) {

        this.data.push({ 
          text: 'Date Sent', 
          value: this.$options.filters.longDate(this.invoice.date_sent) 
        });

        this.data.push({ 
          text: 'Bill to Email', 
          value: this.invoice.bill_to ? this.invoice.bill_to_obj.email : '' 
        });
      }

      this.data.push({ 
        text: 'Division', 
        value: this.invoice.division ? this.invoice.division_obj.division : '' 
      });
    },
    handleBillToSelection(selected){
      this.invoice_edit.bill_to_display = selected.name_display;
      this.invoice_edit.bill_to = selected.id;
    },
    handleSendToSelection(selected){
      this.invoice_edit.send_to_display = selected.name_display;
      this.invoice_edit.send_to = selected.id;
    }
  },
  components: {
    'client-form-search': ClientFormSearch
  }
}
</script>
